//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin'
const config = {"qrcode_img": "https://cdn.vip-wifi.com/fangchan/config/pages/taxes_calculate/taxes_calculate.jpeg"}
export default {
    mixins: [
        mixin
    ],
    data () {
        return {
            result: {
                all_taxes: '',
                all_price: '',
                unit_price: '',
                area: '',
                detail: []
            },
            qrcode_img: config.qrcode_img
        }
    },
    created () {
        const { params }  = this.$route.params
        if (params) {
            this.result = JSON.parse(params)
        } else {
            this.$router.replace({
                path: '/taxes'
            })
        }
    },
}
